






































































































































































































































































































































































































































































































































































































































































































































































































































































import TitleBar from "@/components/Elements/TitleBar.vue";
import Combobox from "@/components/Controls/Combobox.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import moment from "moment";
import XLSX from "xlsx";
import numeral from "numeral";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",
      "laboratoryData",
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ["loadData"]),
  },
  components: {
    TitleBar,
    Combobox,
  },
})
export default class LaboratoryReport extends Vue {
  get titleStack() {
    return ["Отчеты", "По лаборатории"];
  }

  lineTypes = [
    { id: "atom", label: "АТОМ" },
    { id: "vdp", label: "ВДП" },
  ];

  // Колонки для АТОМ с группировкой
  columnsListAtom: any[] = [
    // Основные данные
    { id: "shift_date", label: "Дата смены" },
    { id: "datetime", label: "Дата измерения" },
    { id: "release_datetime", label: "Дата выпуска ГП" },
    { id: "plan_number", label: "Номер партии ГП" },
    {
      id: "produced_product_name",
      label: "Наименование продукта (родитель)",
    },
    {
      id: "product_name",
      label: "Наименование продукта (этикетка)",
    },
    { id: "base_name", label: "ПП из которого варили ГП" },
    { id: "fact_datetime", label: "Дата производства ПП" },
    { id: "plan_number2", label: "№ партии ПП" },
    { id: "target_acidity", label: "Целевая рН" },
    { id: "journal_acidity_4", label: "Фактическая рН Меттлер" },
    { id: "acidity_ohaus_vpr", label: "Фактическая рН Охаус" },
    { id: "acidity_4", label: "рН в образце" },
    { id: "density_vpr", label: "Плотность" },
    { id: "speed_vpr", label: "Скорость шпинделя" },
    { id: "viscosity_vpr", label: "Вязкость" },
    { id: "resistance_vpr", label: "Сопротивление" },
    { id: "temp_vpr", label: "Температура" },
    { id: "acidity_mettler_vpr", label: "РН Меттлер" },
    { id: "acidity_ohaus_gph", label: "РН Охаус" },
    { id: "density_gph", label: "Плотность" },
    { id: "speed_gph", label: "Скорость шпинделя" },
    { id: "viscosity_gph", label: "Вязкость" },
    { id: "resistance_gph", label: "Сопротивление" },
    { id: "temp_gph", label: "Температура" },
    {
      id: "stirability_thermomix_name",
      label: "Размешиваемость в термомиксе",
    },
    {
      id: "glitter_thermomix_name",
      label: "Блеск в термомиксе",
    },
    {
      id: "thermal_stability_name",
      label: "Термостабильность",
    },
    { id: "heat_resistance_name", label: "Термоустойчивость" },
    { id: "hardness_name", label: "Твердость" },
    {
      id: "causticity_initial_spalling_name",
      label: "Колкость при откалывании",
    },
    { id: "plasticity_name", label: "Пластичность" },
    { id: "looseness_name", label: "Плотность / Рыхлость" },
    { id: "sound_product_breaking_name", label: "Звук откола" },
    {
      id: "sound_product_released_name",
      label: "Звук при развозюкивании",
    },
    {
      id: "feeling_of_texture_name",
      label: "Ощущение текстуры",
    },
    { id: "fluff_effect_name", label: "Эффект пух" },
    // Вкус
    { id: "creaminess_longitude", label: "Долгота сливочности" },
    { id: "creaminess_height", label: "Высота сливочности" },
    { id: "kislinka_name", label: "Кислинка" },
    { id: "serbian_profile_name", label: "Сербский профиль" },
    { id: "sweetness_name", label: "Сладость" },
    { id: "salinity_name", label: "Соленость" },
    { id: "vices_name", label: "Пороки вкуса" },
  ];

  // Колонки для ВДП с группировкой
  columnsListVdp: any[] = [
    { id: "shift_date", label: "Дата смены" },
    { id: "datetime", label: "Дата измерения ПП" },
    { id: "plan_number", label: "№ партии ПП" },
    { id: "starter_type_name", label: "Закваска" },
    { id: "extract_time", label: "Дата выемки ПП" },
    { id: "delay_time", label: "Время задержки" },
    { id: "acidity_ohaus", label: "рН Охаус" },
    { id: "acidity_mettler", label: "рН Меттлер" },
    { id: "density_pp", label: "Плотность" },
    { id: "speed", label: "Скорость шпинделя" },
    { id: "viscosity_pp", label: "Вязкость" },
    { id: "resistance_pp", label: "Сопротивление" },
    { id: "temp_pp", label: "Температура" },
  ];

  showColumnsAtom: string[] = [];
  showColumnsVdp: string[] = [];

  private readonly STORAGE_KEY_ATOM = "laboratory_report_columns_atom";
  private readonly STORAGE_KEY_VDP = "laboratory_report_columns_vdp";

  localFilter = {
    targetDates: [new Date(), new Date()],
    lineType: "atom" as string,
  };

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.targetDates =
      this.$route.query && this.$route.query.targetDates
        ? [
            moment(this.$route.query.targetDates[0]).toDate(),
            moment(this.$route.query.targetDates[1]).toDate(),
          ]
        : [new Date(), new Date()];
    // @ts-ignore
    this.localFilter.lineType =
      this.$route.query && this.$route.query.lineType
        ? this.$route.query.lineType
        : "atom";

    // Загрузка сохранённых колонок из localStorage или инициализация всех
    this.loadColumnsFromStorage();

    if (!this.$route.query.targetDates || !this.$route.query.lineType) {
      this.setFilterData();
    } else {
      this.handleParamsChange();
    }
  }

  setFilterData() {
    const query: any = {};
    if (this.localFilter.targetDates) {
      query.targetDates = [
        moment(this.localFilter.targetDates[0]).format("YYYY-MM-DD"),
        moment(this.localFilter.targetDates[1]).format("YYYY-MM-DD"),
      ];
    }
    if (this.localFilter.lineType) {
      query.lineType = this.localFilter.lineType;
    }

    this.$router.replace({
      query,
    });
  }

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  @Watch("showColumnsAtom")
  public onShowColumnsAtomChange() {
    this.saveColumnsToStorage();
  }

  @Watch("showColumnsVdp")
  public onShowColumnsVdpChange() {
    this.saveColumnsToStorage();
  }

  private loadColumnsFromStorage() {
    try {
      const savedAtom = localStorage.getItem(this.STORAGE_KEY_ATOM);
      const savedVdp = localStorage.getItem(this.STORAGE_KEY_VDP);

      if (savedAtom) {
        const parsedAtom = JSON.parse(savedAtom);
        // Фильтруем, чтобы оставить только существующие колонки
        this.showColumnsAtom = parsedAtom.filter((id: string) =>
          this.columnsListAtom.some((col: any) => col.id === id)
        );
      } else {
        this.showColumnsAtom = this.columnsListAtom.map((col: any) => col.id);
      }

      if (savedVdp) {
        const parsedVdp = JSON.parse(savedVdp);
        // Фильтруем, чтобы оставить только существующие колонки
        this.showColumnsVdp = parsedVdp.filter((id: string) =>
          this.columnsListVdp.some((col: any) => col.id === id)
        );
      } else {
        this.showColumnsVdp = this.columnsListVdp.map((col: any) => col.id);
      }
    } catch (e) {
      // В случае ошибки используем все колонки
      this.showColumnsAtom = this.columnsListAtom.map((col: any) => col.id);
      this.showColumnsVdp = this.columnsListVdp.map((col: any) => col.id);
    }
    console.log("Saved Atom Columns:", this.showColumnsAtom);
    console.log("Saved Atom Columns:", this.columnsListAtom);
    console.log("Saved VDP Columns:", this.showColumnsVdp);
    console.log("Saved VDP Columns:", this.columnsListVdp);
  }

  private saveColumnsToStorage() {
    try {
      localStorage.setItem(
        this.STORAGE_KEY_ATOM,
        JSON.stringify(this.showColumnsAtom)
      );
      localStorage.setItem(
        this.STORAGE_KEY_VDP,
        JSON.stringify(this.showColumnsVdp)
      );
    } catch (e) {
      // Игнорируем ошибки записи в localStorage
    }
  }

  private colorMap: Map<string, string> = new Map();
  private colorCounter = 0;

  public getColorCellClass(color: string | null | undefined): string {
    if (!color || color === "transparent") {
      return "";
    }

    if (!this.colorMap.has(color)) {
      const className = `cell-color-${this.colorCounter++}`;
      this.colorMap.set(color, className);

      this.$nextTick(() => {
        const styleId = `dynamic-cell-colors`;
        let styleEl = document.getElementById(styleId) as HTMLStyleElement;

        if (!styleEl) {
          styleEl = document.createElement("style");
          styleEl.id = styleId;
          document.head.appendChild(styleEl);
        }

        const rule = `.table td.${className} { background-color: ${color} !important; }`;
        if (styleEl.sheet && !styleEl.textContent?.includes(className)) {
          styleEl.textContent += rule;
        }
      });
    }

    return this.colorMap.get(color) || "";
  }

  public getCreaminessCellClass(row: any, type: string): string {
    if (type === "longitude") {
      return row.creaminess_longitude > row.border_creaminess_longitude
        ? "clot-ok1"
        : "clot-middle";
    } else if (type === "height") {
      return row.creaminess_height > row.border_creaminess_height
        ? "clot-ok1"
        : "clot-middle";
    }
    return "";
  }

  public isLastMeasurement(row: any, lineType: string): boolean {
    const laboratoryData = (this as any).laboratoryData;

    if (
      lineType === "atom" &&
      laboratoryData.atom &&
      laboratoryData.atom.length > 0
    ) {
      const lastMeasurement = laboratoryData.atom[0];
      return (
        row.datetime &&
        lastMeasurement.datetime &&
        row.datetime === lastMeasurement.datetime
      );
    }

    if (
      lineType === "vdp" &&
      laboratoryData.vdp &&
      laboratoryData.vdp.length > 0
    ) {
      const lastMeasurement = laboratoryData.vdp[0];
      return (
        row.datetime &&
        lastMeasurement.datetime &&
        row.datetime === lastMeasurement.datetime
      );
    }

    return false;
  }

  public getCombinedCellClass(
    row: any,
    lineType: string,
    color?: string | null,
    creaminessType?: string
  ): string {
    const classes: string[] = [];

    if (color) {
      const colorClass = this.getColorCellClass(color);
      if (colorClass) {
        classes.push(colorClass);
      }
    }

    if (creaminessType) {
      const creaminessClass = this.getCreaminessCellClass(row, creaminessType);
      if (creaminessClass) {
        classes.push(creaminessClass);
      }
    }

    return classes.join(" ");
  }

  // Маппинг колонок ATOM для экспорта
  private atomColumnsExportMap: {
    [key: string]: {
      header: string;
      getValue: (row: any) => string | number;
    };
  } = {
    shift_date: {
      header: "Дата смены",
      getValue: (row: any) =>
        row.shift_date ? moment(row.shift_date).format("DD.MM.YYYY") : "",
    },
    datetime: {
      header: "Дата измерения",
      getValue: (row: any) =>
        row.datetime ? moment(row.datetime).format("DD.MM.YYYY HH:mm") : "",
    },
    release_datetime: {
      header: "Дата выпуска ГП",
      getValue: (row: any) =>
        row.release_datetime
          ? moment(row.release_datetime).format("DD.MM.YYYY")
          : "",
    },
    plan_number: {
      header: "Номер партии ГП",
      getValue: (row: any) => row.plan_number || "",
    },
    produced_product_name: {
      header: "Наименование продукта (родитель)",
      getValue: (row: any) => row.produced_product_name || "",
    },
    product_name: {
      header: "Наименование продукта (этикетка)",
      getValue: (row: any) => row.product_name || "",
    },
    base_name: {
      header: "ПП из которого варили ГП",
      getValue: (row: any) => row.base_name || "",
    },
    fact_datetime: {
      header: "Дата производства ПП",
      getValue: (row: any) =>
        row.fact_datetime
          ? moment(row.fact_datetime).format("DD.MM.YYYY HH:mm")
          : "",
    },
    plan_number2: {
      header: "№ партии ПП",
      getValue: (row: any) => row.plan_number2 || "",
    },
    target_acidity: {
      header: "Целевая рН ВПР",
      getValue: (row: any) =>
        row.target_acidity != null && row.target_acidity !== ""
          ? numeral(row.target_acidity).format("0,0.00")
          : "0,00",
    },
    journal_acidity_4: {
      header: "Фактическая рН Меттлер ВПР",
      getValue: (row: any) =>
        row.journal_acidity_4 != null && row.journal_acidity_4 !== ""
          ? numeral(row.journal_acidity_4).format("0,0.00")
          : "0,00",
    },
    acidity_ohaus_vpr: {
      header: "Фактическая рН Охаус ВПР",
      getValue: (row: any) =>
        row.acidity_ohaus_vpr != null && row.acidity_ohaus_vpr !== ""
          ? numeral(row.acidity_ohaus_vpr).format("0,0.00")
          : "0,00",
    },
    acidity_4: {
      header: "рН в образце",
      getValue: (row: any) =>
        row.acidity_4 != null && row.acidity_4 !== ""
          ? numeral(row.acidity_4).format("0,0.00")
          : "0,00",
    },
    density_vpr: {
      header: "Плотность, которая задается на вискозиметре для ВПР",
      getValue: (row: any) =>
        row.density_vpr != null && row.density_vpr !== ""
          ? numeral(row.density_vpr).format("0,0.00")
          : "0,00",
    },
    speed_vpr: {
      header: "Скорость шпинделя в ВПР",
      getValue: (row: any) =>
        row.speed_vpr != null && row.speed_vpr !== ""
          ? numeral(row.speed_vpr).format("0,0.00")
          : "0,00",
    },
    viscosity_vpr: {
      header: "Вязкость ВПР, мПа*с",
      getValue: (row: any) =>
        row.viscosity_vpr != null && row.viscosity_vpr !== ""
          ? numeral(row.viscosity_vpr).format("0,0.00")
          : "0,00",
    },
    resistance_vpr: {
      header: "Сопротивление ВПР",
      getValue: (row: any) =>
        row.resistance_vpr != null && row.resistance_vpr !== ""
          ? numeral(row.resistance_vpr).format("0,0.00")
          : "0,00",
    },
    temp_vpr: {
      header: "t ВПР, 0C",
      getValue: (row: any) =>
        row.temp_vpr != null && row.temp_vpr !== ""
          ? numeral(row.temp_vpr).format("0,0.00")
          : "0,00",
    },
    acidity_mettler_vpr: {
      header: "РН Меттлер ГПХ",
      getValue: (row: any) =>
        row.acidity_mettler_vpr != null && row.acidity_mettler_vpr !== ""
          ? numeral(row.acidity_mettler_vpr).format("0,0.00")
          : "0,00",
    },
    acidity_ohaus_gph: {
      header: "РН Охаус ГПХ",
      getValue: (row: any) =>
        row.acidity_ohaus_vpr != null && row.acidity_ohaus_vpr !== ""
          ? numeral(row.acidity_ohaus_vpr).format("0,0.00")
          : "0,00",
    },
    density_gph: {
      header: "Плотность, которая задается на вискозиметре для ГПХ",
      getValue: (row: any) =>
        row.density_gph != null && row.density_gph !== ""
          ? numeral(row.density_gph).format("0,0.00")
          : "0,00",
    },
    speed_gph: {
      header: "Скорость шпинделя в ГПХ",
      getValue: (row: any) =>
        row.speed_gph != null && row.speed_gph !== ""
          ? numeral(row.speed_gph).format("0,0.00")
          : "0,00",
    },
    viscosity_gph: {
      header: "Вязкость ГПХ, мПа*с",
      getValue: (row: any) =>
        row.viscosity_gph != null && row.viscosity_gph !== ""
          ? numeral(row.viscosity_gph).format("0,0.00")
          : "0,00",
    },
    resistance_gph: {
      header: "Сопротивление ГПХ",
      getValue: (row: any) =>
        row.resistance_gph != null && row.resistance_gph !== ""
          ? numeral(row.resistance_gph).format("0,0.00")
          : "0,00",
    },
    temp_gph: {
      header: "t ГПХ, 0C",
      getValue: (row: any) =>
        row.temp_gph != null && row.temp_gph !== ""
          ? numeral(row.temp_gph).format("0,0.00")
          : "0,00",
    },
    stirability_thermomix_name: {
      header: "Размешиваемость в термомиксе",
      getValue: (row: any) => row.stirability_thermomix_name || "",
    },
    glitter_thermomix_name: {
      header: "Блеск в термомиксе",
      getValue: (row: any) => row.glitter_thermomix_name || "",
    },
    thermal_stability_name: {
      header: "Термостабильность (микроволновка)",
      getValue: (row: any) => row.thermal_stability_name || "",
    },
    heat_resistance_name: {
      header: "Термоустойчивость (шарик)",
      getValue: (row: any) => row.heat_resistance_name || "",
    },
    hardness_name: {
      header: "Твердость",
      getValue: (row: any) => row.hardness_name || "",
    },
    causticity_initial_spalling_name: {
      header: "Колкость при первичном откалывании",
      getValue: (row: any) => row.causticity_initial_spalling_name || "",
    },
    plasticity_name: {
      header: "Пластичность (эффект масличка)",
      getValue: (row: any) => row.plasticity_name || "",
    },
    looseness_name: {
      header: "Плотность / Рыхлость",
      getValue: (row: any) => row.looseness_name || "",
    },
    sound_product_breaking_name: {
      header: "Звук откола продукта лопаткой от общей массы",
      getValue: (row: any) => row.sound_product_breaking_name || "",
    },
    sound_product_released_name: {
      header: "Звук при развозюкивании продукта",
      getValue: (row: any) => row.sound_product_released_name || "",
    },
    feeling_of_texture_name: {
      header: "Ощущение текстуры во рту",
      getValue: (row: any) => row.feeling_of_texture_name || "",
    },
    fluff_effect_name: {
      header: 'Скорость растворения во рту (эффект "пух")',
      getValue: (row: any) => row.fluff_effect_name || "",
    },
    creaminess_longitude: {
      header: "Долгота сливочности",
      getValue: (row: any) =>
        row.creaminess_longitude != null && row.creaminess_longitude !== ""
          ? row.creaminess_longitude
          : "0",
    },
    creaminess_height: {
      header: "Высота сливочности",
      getValue: (row: any) =>
        row.creaminess_height != null && row.creaminess_height !== ""
          ? row.creaminess_height
          : "0",
    },
    kislinka_name: {
      header: "Кислинка",
      getValue: (row: any) => row.kislinka_name || "",
    },
    serbian_profile_name: {
      header: "Сербский профиль",
      getValue: (row: any) => row.serbian_profile_name || "",
    },
    sweetness_name: {
      header: "Сладость",
      getValue: (row: any) => row.sweetness_name || "",
    },
    salinity_name: {
      header: "Соленость",
      getValue: (row: any) => row.salinity_name || "",
    },
    vices_name: {
      header: "Пороки вкуса",
      getValue: (row: any) => row.vices_name || "",
    },
  };

  // Маппинг колонок VDP для экспорта
  private vdpColumnsExportMap: {
    [key: string]: {
      header: string;
      getValue: (row: any) => string | number;
    };
  } = {
    shift_date: {
      header: "Дата смены",
      getValue: (row: any) =>
        row.shift_date ? moment(row.shift_date).format("DD.MM.YYYY") : "",
    },
    datetime: {
      header: "Дата измерения ПП",
      getValue: (row: any) =>
        row.datetime ? moment(row.datetime).format("DD.MM.YYYY HH:mm") : "",
    },
    plan_number: {
      header: "№ партии ПП",
      getValue: (row: any) => row.plan_number || "",
    },
    starter_type_name: {
      header: "Закваска",
      getValue: (row: any) => row.starter_type_name || "",
    },
    extract_time: {
      header: "Дата выемки ПП",
      getValue: (row: any) =>
        row.extract_time
          ? moment(row.extract_time).format("DD.MM.YYYY HH:mm")
          : "",
    },
    delay_time: {
      header: "Время задержки",
      getValue: (row: any) => row.delay_time || "",
    },
    acidity_ohaus: {
      header: "рН Охаус ПП",
      getValue: (row: any) =>
        row.acidity_ohaus != null && row.acidity_ohaus !== ""
          ? numeral(row.acidity_ohaus).format("0,0.00")
          : "0,00",
    },
    acidity_mettler: {
      header: "рН Меттлер ПП",
      getValue: (row: any) =>
        row.acidity_mettler != null && row.acidity_mettler !== ""
          ? numeral(row.acidity_mettler).format("0,0.00")
          : "0,00",
    },
    density_pp: {
      header: "Плотность ПП",
      getValue: (row: any) =>
        row.density_pp != null && row.density_pp !== ""
          ? numeral(row.density_pp).format("0,0.00")
          : "0,00",
    },
    speed: {
      header: "Скорость шпинделя",
      getValue: (row: any) =>
        row.speed != null && row.speed !== ""
          ? numeral(row.speed).format("0,0.00")
          : "0,00",
    },
    viscosity_pp: {
      header: "Вязкость ПП",
      getValue: (row: any) =>
        row.viscosity_pp != null && row.viscosity_pp !== ""
          ? row.viscosity_pp
          : "0",
    },
    resistance_pp: {
      header: "Сопротивление ПП",
      getValue: (row: any) =>
        row.resistance_pp != null && row.resistance_pp !== ""
          ? numeral(row.resistance_pp).format("0,0.00")
          : "0,00",
    },
    temp_pp: {
      header: "t ПП, °C",
      getValue: (row: any) =>
        row.temp_pp != null && row.temp_pp !== ""
          ? numeral(row.temp_pp).format("0,0.00")
          : "0,00",
    },
  };

  public exportToXLSX() {
    const wb = XLSX.utils.book_new();
    const laboratoryData = (this as any).laboratoryData;

    if (
      (!this.localFilter.lineType || this.localFilter.lineType === "atom") &&
      laboratoryData &&
      laboratoryData.atom &&
      laboratoryData.atom.length > 0
    ) {
      // Фильтруем колонки на основе выбранных
      const visibleAtomColumns = this.columnsListAtom
        .filter((col: any) => this.showColumnsAtom.includes(col.id))
        .map((col: any) => col.id);

      const atomHeaders = visibleAtomColumns
        .filter((id: string) => this.atomColumnsExportMap[id])
        .map((id: string) => this.atomColumnsExportMap[id].header);

      const atomData = laboratoryData.atom.map((row: any) =>
        visibleAtomColumns
          .filter((id: string) => this.atomColumnsExportMap[id])
          .map((id: string) => this.atomColumnsExportMap[id].getValue(row))
      );

      const atomSheet = XLSX.utils.aoa_to_sheet([atomHeaders, ...atomData]);
      XLSX.utils.book_append_sheet(wb, atomSheet, "Лаборатория АТОМ");
    }

    if (
      (!this.localFilter.lineType || this.localFilter.lineType === "vdp") &&
      laboratoryData &&
      laboratoryData.vdp &&
      laboratoryData.vdp.length > 0
    ) {
      // Фильтруем колонки на основе выбранных
      const visibleVdpColumns = this.columnsListVdp
        .filter((col: any) => this.showColumnsVdp.includes(col.id))
        .map((col: any) => col.id);

      const vdpHeaders = visibleVdpColumns
        .filter((id: string) => this.vdpColumnsExportMap[id])
        .map((id: string) => this.vdpColumnsExportMap[id].header);

      const vdpData = laboratoryData.vdp.map((row: any) =>
        visibleVdpColumns
          .filter((id: string) => this.vdpColumnsExportMap[id])
          .map((id: string) => this.vdpColumnsExportMap[id].getValue(row))
      );

      const vdpSheet = XLSX.utils.aoa_to_sheet([vdpHeaders, ...vdpData]);
      XLSX.utils.book_append_sheet(wb, vdpSheet, "Лаборатория ВДП");
    }

    const dateFrom = this.localFilter.targetDates[0]
      ? moment(this.localFilter.targetDates[0]).format("DD.MM.YYYY")
      : "";
    const dateTo = this.localFilter.targetDates[1]
      ? moment(this.localFilter.targetDates[1]).format("DD.MM.YYYY")
      : "";
    const fileName = `Отчет_по_лаборатории_${dateFrom}_${dateTo}.xlsx`;

    XLSX.writeFile(wb, fileName);
  }
}
